var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32 16.5C32 21.2286 29.9487 25.4781 26.6875 28.4072V27.0625C26.6875 25.4878 26.0619 23.9776 24.9484 22.8641C23.8349 21.7506 22.3247 21.125 20.75 21.125H11.25C9.67528 21.125 8.16505 21.7506 7.05155 22.8641C5.93806 23.9776 5.3125 25.4878 5.3125 27.0625V28.4072C2.05127 25.4781 0 21.2286 0 16.5C0 7.66344 7.16344 0.5 16 0.5C24.8366 0.5 32 7.66344 32 16.5ZM24.3125 29.4375C24.3125 29.6673 24.3778 29.8819 24.4908 30.0637C22.03 31.6074 19.1193 32.5 16 32.5C12.8807 32.5 9.96997 31.6074 7.50917 30.0637C7.62221 29.8819 7.6875 29.6673 7.6875 29.4375V27.0625C7.6875 26.1177 8.06283 25.2115 8.73093 24.5434C9.39903 23.8753 10.3052 23.5 11.25 23.5H20.75C21.6948 23.5 22.601 23.8753 23.2691 24.5434C23.9372 25.2115 24.3125 26.1177 24.3125 27.0625V29.4375ZM12.4375 12.8125C12.4375 10.845 14.0325 9.25 16 9.25C17.9675 9.25 19.5625 10.845 19.5625 12.8125C19.5625 14.78 17.9675 16.375 16 16.375C14.0325 16.375 12.4375 14.78 12.4375 12.8125ZM16 6.875C12.7208 6.875 10.0625 9.53331 10.0625 12.8125C10.0625 16.0917 12.7208 18.75 16 18.75C19.2792 18.75 21.9375 16.0917 21.9375 12.8125C21.9375 9.53331 19.2792 6.875 16 6.875Z",
    fill: "#C4C4C4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.35834c7ed69ef407e5dd39491ea484b9.svg";
export { ForwardRef as ReactComponent };